var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAction',[_c('SecondaryButton',{attrs:{"textColor":"#d10a3a"},nativeOn:{"click":function($event){return _vm.print.apply(null, arguments)}}},[_c('inline-svg',{attrs:{"src":require('@/assets/svg/file__icon-pdf.svg'),"width":"25"}}),_vm._v(" Print Timesheet(s) ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }